import React, { useEffect, useState, useContext } from 'react'
// NAVIGATION
import { useNavigate } from 'react-router-dom'
// APP CONTEXT
import { AppContext } from '../../../App'
// SPINNER
import Spinner from '../../../components.js/elements/Spinner'
// FIREBASE
import useFirebase from './../../../firebase/useFirebase'
// HEADER EQUIPE
import HeaderHomeEquipe from '../../../components.js/equipe/homePageEquipe/HeaderHomeEquipe'
import ViewButtonsEquipe from '../../../components.js/equipe/homePageEquipe/ViewButtonsEquipe'

const HomePageEquipe = () => {
    const { user } = useContext(AppContext)
    const { readData, readDataMessagesChat, profil, count, messagesChat } = useFirebase()
    const [montage, setMontage] = useState(true)
    let navigate = useNavigate()
    
    return (
        <div className='container-fluid'>
 
            {/* HEADER */}
            <HeaderHomeEquipe
                surname='michel'
                name='laurent'
            />

            {/* BUTTONS */}
            <ViewButtonsEquipe
                profil={profil}
                messagesChat={messagesChat}
            />

        </div>
    )
}
 
export default HomePageEquipe